import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { STORE } from "../config/store";
import "../css/policy.scss";

function PolicyPage({ title, intro, sections, related = [] }) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <main className="policy-page">
      <nav className="policy-breadcrumb" aria-label="Breadcrumb">
        <Link to="/">Home</Link>
        <span aria-hidden="true">/</span>
        <span>{title}</span>
      </nav>
      <article className="policy-card">
        <p className="policy-kicker">{STORE.brand} · {STORE.operatingRegion}</p>
        <h1>{title}</h1>
        <p className="policy-effective">Effective {STORE.policyEffectiveDate}</p>
        {intro && <p className="policy-intro">{intro}</p>}
        {sections.map((section) => (
          <section key={section.title} id={section.id}>
            <h2>{section.title}</h2>
            {section.paragraphs?.map((paragraph, index) => (
              <p key={index}>{paragraph}</p>
            ))}
            {section.items && (
              <ul>
                {section.items.map((item, index) => <li key={index}>{item}</li>)}
              </ul>
            )}
            {section.links && (
              <ul className="policy-links">
                {section.links.map(([label, to]) => <li key={to}><Link to={to}>{label}</Link></li>)}
              </ul>
            )}
          </section>
        ))}
        {related.length > 0 && (
          <aside className="policy-related" aria-label="Related policies">
            <h2>Related policies</h2>
            <ul>{related.map(([label, to]) => <li key={to}><Link to={to}>{label}</Link></li>)}</ul>
          </aside>
        )}
        <p className="policy-contact">
          Questions or requests: <a href={`mailto:${STORE.supportEmail}`}>{STORE.supportEmail}</a>
        </p>
      </article>
    </main>
  );
}

export default PolicyPage;
